import { AutogenLayoutDriverSettlementProfileList } from "./autogen/AutogenLayoutDriverSettlementProfileList";
import { Image, TableRowDisplayEvent } from "@mcleod/components";

export class DriverSettlementProfileList extends AutogenLayoutDriverSettlementProfileList {
    tableDriverSettlementProfilesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();

        const imageProfileColor = tableRow.findComponentById("imageProfileColor") as Image;
        if (imageProfileColor != null) {
            const profileColor = tableRow.data?.getString("profile_color", null);
            imageProfileColor.color = profileColor;
            imageProfileColor.visible = profileColor != null;
        }
    }
}
